"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _fastdom = _interopRequireDefault(require("fastdom"));

var _Aria2 = _interopRequireDefault(require("./Aria"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Manage aria-haspopup elements
 *
 * @param {Object} config                 Config options for AriaPopup
 * @param {HTMLElement} config.controller The controlling element
 * @param {HTMLElement} config.target     The element controlled by `controller`
 * @param {Object} config.attributes      An Object of aria-* attributes to be added to the `target`, where the key
 *                                        completes an 'aria-' attribute name and the value is a valid attribute value.
 * @param {Boolean} config.loadOpen       Whether or not the popup should load expanded by default
 * @param {String} config.hasTransition   Delay updating post- hide/show routines until after `transitionend`
 *
 * E.g.:
 * const popup = new AriaPopup({
 *   controller: controllingButton,
 *   target: targetElement,
 *   attributes: {
 *     label: 'submenu'
 *     labelledby: 'element-id'
 *     describedby: 'verbose-element-id'
 *   }
 *   loadOpen: true,
 *   hasTransition: true,
 * });
 */
var AriaPopup = /*#__PURE__*/function (_Aria) {
  (0, _inherits2.default)(AriaPopup, _Aria);

  var _super = _createSuper(AriaPopup);

  function AriaPopup(config) {
    var _this;

    (0, _classCallCheck2.default)(this, AriaPopup);
    _this = _super.call(this);
    _this.controller = config.controller;
    _this.target = config.target;
    _this.attributes = config.attributes || {};
    _this._loadOpen = config.loadOpen || false;
    _this.hasTransition = config.hasTransition || false;
    _this.targetElement = _this.target;
    _this.targetAttr = {}; // Bind class methods

    _this.setTargetAttributes = _this.setTargetAttributes.bind((0, _assertThisInitialized2.default)(_this));
    _this.rovingTabIndex = _this.rovingTabIndex.bind((0, _assertThisInitialized2.default)(_this));
    _this.outsideClick = _this.outsideClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.keyDownHandler = _this.keyDownHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.keydownTabOut = _this.keydownTabOut.bind((0, _assertThisInitialized2.default)(_this));
    _this.keydownEsc = _this.keydownEsc.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaSetup = _this.ariaSetup.bind((0, _assertThisInitialized2.default)(_this));
    _this._hide = _this._hide.bind((0, _assertThisInitialized2.default)(_this));
    _this._show = _this._show.bind((0, _assertThisInitialized2.default)(_this));
    _this._postToggle = _this._postToggle.bind((0, _assertThisInitialized2.default)(_this));
    _this._destroy = _this._destroy.bind((0, _assertThisInitialized2.default)(_this));
    _this._reset = _this._reset.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaHide = _this.ariaHide.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaShow = _this.ariaShow.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaToggle = _this.ariaToggle.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaDestroy = _this.ariaDestroy.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaReset = _this.ariaReset.bind((0, _assertThisInitialized2.default)(_this));

    _this.collectInteractiveChildren();

    _this.setTargetAttributes();

    _Aria2.default.eventPolyfill();

    _this.ariaSetup();

    return _this;
  }
  /**
   * Add initial attributes, establish relationships, and listen for events
   */


  (0, _createClass2.default)(AriaPopup, [{
    key: "ariaSetup",
    value: function ariaSetup() {
      var _this2 = this;

      this.loadOpen = this._loadOpen;
      this.isExpanded = this._loadOpen;
      this.controller.popup = this;
      this.target.popup = this;
      this.controller.setAttribute('aria-haspopup', 'true');
      this.controller.setAttribute('aria-expanded', "".concat(this.loadOpen));
      this.controller.setAttribute('aria-controls', this.targetId);

      if (this.target !== this.controller.nextElementSibling) {
        this.controller.setAttribute('aria-owns', this.targetId);
      }

      this.target.setAttribute('aria-hidden', "".concat(!this.loadOpen));
      Object.keys(this.targetAttr).forEach(function (attr) {
        _this2.target.setAttribute(attr, _this2.targetAttr[attr]);
      });
      this.rovingTabIndex();
      this.controller.addEventListener('click', this.ariaToggle);
      this.target.addEventListener('keydown', this.keyDownHandler);
      document.body.addEventListener('click', this.outsideClick);

      if (this.hasTransition) {
        this.target.addEventListener('transitionend', this._postToggle);
      }

      _Aria2.default.dispatchAriaEvent('popupinit', {
        expanded: this.isExpanded
      }, this.controller);
    }
    /**
     * Copy attributes over as their full attribute name.
     */

  }, {
    key: "setTargetAttributes",
    value: function setTargetAttributes() {
      var _this3 = this;

      if ('object' === (0, _typeof2.default)(this.attributes)) {
        Object.keys(this.attributes).forEach(function (prop) {
          _this3.targetAttr["aria-".concat(prop)] = _this3.attributes[prop];
        });
      } // Configure a target element ID if it doesn't exist.


      if ('' !== this.target.id) {
        this.targetId = this.target.id;
      } else {
        this.targetId = _Aria2.default.generateTargetId(this.target);
        this.target.id = this.targetId;
      }
    }
    /**
     * Close the dialog on outside click.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "outsideClick",
    value: function outsideClick(event) {
      if (this.isExpanded && !this.loadOpen && !this.controller.contains(event.target) && !this.target.contains(event.target)) {
        this.ariaHide();
      }
    }
    /**
     * Handle key presses.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(event) {
      if (this.isExpanded && !this.loadOpen) {
        if (event.keyCode === this.tabKey) {
          this.keydownTabOut(event);
        } else if (event.keyCode === this.escapeKey) {
          event.stopPropagation();
          this.keydownEsc();
        }
      }
    }
    /**
     * Close the dialog on ESC key press.
     */

  }, {
    key: "keydownEsc",
    value: function keydownEsc() {
      this.ariaHide();
    }
    /**
     * Close submenu on tab-out.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "keydownTabOut",
    value: function keydownTabOut(event) {
      var focusedIndex = Array.prototype.indexOf.call(this.interactiveChildElements, document.activeElement);

      if (event.shiftKey && 0 === focusedIndex) {
        event.preventDefault();
        this.ariaHide();
      } else if (!event.shiftKey && focusedIndex === this.interactiveChildElements.length - 1) {
        this.ariaHide();
      }
    }
    /**
     * Prevent hidden menu items from having focus.
     */

  }, {
    key: "rovingTabIndex",
    value: function rovingTabIndex() {
      var _this4 = this;

      this.collectInteractiveChildren();
      Array.prototype.forEach.call(this.interactiveChildElements, function (child) {
        if (_this4.isExpanded) {
          child.removeAttribute('tabindex');
        } else {
          child.setAttribute('tabindex', '-1');
        }
      });
    }
    /**
     * Post-toggle cleanup.
     * Adjust focus and tabindex, dispatch the event.
     *
     * @private
     */

  }, {
    key: "_postToggle",
    value: function _postToggle(event) {
      if (undefined === event || this.target === event.target) {
        if (this.isExpanded) {
          this.collectInteractiveChildren();
          this.rovingTabIndex();
        } else {
          this.rovingTabIndex();
        }

        _Aria2.default.dispatchAriaEvent(this.isExpanded ? 'popupshow' : 'popuphide', {
          expanded: this.isExpanded
        }, this.controller);
      }
    }
    /**
     * Externally-exposed hide method
     */

  }, {
    key: "ariaHide",
    value: function ariaHide() {
      _fastdom.default.mutate(this._hide);
    }
    /**
     * ARIA-hide the target element.
     *
     * @private
     */

  }, {
    key: "_hide",
    value: function _hide() {
      if (this.target.contains(document.activeElement)) {
        this.controller.focus();
      }

      this.controller.setAttribute('aria-expanded', 'false');
      this.target.setAttribute('aria-hidden', 'true');
      this.isExpanded = false;
      this.loadOpen = false;

      if (!this.hasTransition) {
        this._postToggle();
      }
    }
    /**
     * Externally-exposed show method
     */

  }, {
    key: "ariaShow",
    value: function ariaShow() {
      _fastdom.default.mutate(this._show);
    }
    /**
     * ARIA-show the target element.
     *
     * @private
     */

  }, {
    key: "_show",
    value: function _show() {
      this.controller.setAttribute('aria-expanded', 'true');
      this.target.setAttribute('aria-hidden', 'false');
      this.isExpanded = true;

      if (!this.hasTransition) {
        this._postToggle();
      }
    }
    /**
     * Toggle ARIA attributes.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "ariaToggle",
    value: function ariaToggle(event) {
      event.preventDefault();

      if (this.isExpanded) {
        this.ariaHide();
      } else {
        this.ariaShow();
      }
    }
    /**
     * Externally-exposed destroy method
     */

  }, {
    key: "ariaDestroy",
    value: function ariaDestroy() {
      _fastdom.default.mutate(this._destroy);
    }
    /**
     * Remove all ARIA attributes added by this class.
     *
     * @private
     */

  }, {
    key: "_destroy",
    value: function _destroy() {
      var _this5 = this;

      if (this.target.contains(document.activeElement)) {
        this.controller.focus();
      }

      this.controller.removeAttribute('aria-haspopup');
      this.controller.removeAttribute('aria-expanded');
      this.controller.removeAttribute('aria-controls');
      this.controller.removeAttribute('aria-owns');
      this.target.removeAttribute('aria-hidden');
      Object.keys(this.targetAttr).forEach(function (attr) {
        _this5.target.removeAttribute(attr, _this5.targetAttr[attr]);
      });
      this.isExpanded = false;
      this.loadOpen = false;
      this.collectInteractiveChildren();
      Array.prototype.forEach.call(this.interactiveChildElements, function (child) {
        child.removeAttribute('tabindex');
      });
      this.controller.removeEventListener('click', this.ariaToggle);
      this.target.removeEventListener('keydown', this.keyDownHandler);
      this.target.removeEventListener('transitionend', this._postToggle);
      document.body.removeEventListener('click', this.outsideClick);

      _Aria2.default.dispatchAriaEvent('popupdestroy', {
        expanded: this.isExpanded
      }, this.controller);
    }
    /**
     * Externally-exposed reset method
     */

  }, {
    key: "ariaReset",
    value: function ariaReset() {
      _fastdom.default.mutate(this._reset);
    }
    /**
     * Reset ARIA attributes.
     *
     * @private
     */

  }, {
    key: "_reset",
    value: function _reset() {
      this.ariaSetup();

      if (this.target.contains(document.activeElement)) {
        this.controller.focus();
      }
    }
  }]);
  return AriaPopup;
}(_Aria2.default);

exports.default = AriaPopup;